import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import { IAPage } from "./pages/IAPage";
import { DocumentacionPage } from "./pages/DocumentacionPage";
import { TerminosPage } from "./pages/TerminosPage";
import { ReembolsosPage } from "./pages/ReembolsosPage";
import { PrivacidadPage } from "./pages/PrivacidadPage";
import { TerminosIAPage } from "./pages/TerminosIAPage";
import { PrivacidadIAPage } from "./pages/PrivacidadIAPage";
import { AfiliadosPage } from "./pages/AfiliadosPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/ia" element={<IAPage />} />
        <Route path="/documentacion" element={<DocumentacionPage />} />
        <Route path="/afiliados" element={<AfiliadosPage />} />
        <Route path="/terminos" element={<TerminosPage />} />
        <Route path="/reembolsos" element={<ReembolsosPage />} />
        <Route path="/privacidad" element={<PrivacidadPage />} />
        <Route path="/terminos-ia" element={<TerminosIAPage />} />
        <Route path="/privacidad-ia" element={<PrivacidadIAPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
